import { DialogActions } from "@material-ui/core";

export type { DialogActionsProps } from "@material-ui/core";

export default DialogActions;
